import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { approveTicketVaulting, getCustodialHolding, getCustodialHoldingsForUserId, vaultTicket } from "../../core/db/custodial";
import { 
    TicketError,
    TicketsState,
    Ticket,
    FetchTicketDetailsByTicketAddressParams,
    VaultTicketParams,
} from "./types";

const initialState: TicketsState = {
    tickets: new Map<number, Ticket>(),
    loading: false,
    vaultLoading: false,
    error: TicketError.NONE,
    vaultSuccessful: 'NA',
}

export const fetchTicketDetails = createAsyncThunk('tickets/fetchTicketDetails',
    async (args: FetchTicketDetailsByTicketAddressParams) => {
        console.log('start');
        const ticketsRes = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/ticket/address?ticketAddress=${args.ticketAddress}`);
    
        if(ticketsRes.status != 200) Error("TICKETS_FETCH_FAILURE");
    
        const json = await ticketsRes.json();
        console.log(json);
        return json.ticket as Ticket
});

export const submitVaultTicket = createAsyncThunk('tickets/vaultTicket',
    async (args: VaultTicketParams) => {

    console.log('start');
    await approveTicketVaulting(args.supabase, args.ticketAddress, args.tokenId, args.userId);

    const params = { 
        ticketAddress: args.ticketAddress,
        tokenId: String(args.tokenId),
        userId: args.userId
    };

    const gg = JSON.stringify(params);
    console.log(gg);
    const ff = JSON.parse(gg);
    console.log(ff);
    // Generate ticket
    const generateRes = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/ticket/generateCode`,
    {
        method: 'POST',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *client
        body: JSON.stringify(params)
    });

    if(generateRes.status != 200) Error("TICKET_GENERATION_FAILURE");

    const json = await generateRes.json();
    console.log(json);
    return true
});

export const ticketsSlice = createSlice({
    name: 'tickets',
    initialState,
    reducers: {
        loading: (state) => { state.loading = true },
        fetched: (state) => { state.loading = false },
        clear: (state) => { state = initialState },
    },
    extraReducers: (builder) => {
        // === Fetch Ticket Details ===
        builder.addCase(fetchTicketDetails.pending, (state) => {
            console.log('PENDING');
            state.loading = true;
        })
        builder.addCase(fetchTicketDetails.fulfilled, (state, action: PayloadAction<Ticket>) => {
            console.log('FULFILLED');
            console.log(action.payload);
            // Add ticket details to state
            const newTicketMap = state.tickets;
            newTicketMap.set(action.payload.id, action.payload);

            state.tickets = newTicketMap;
            state.loading = false;
            state.error = TicketError.NONE;
        })
        builder.addCase(fetchTicketDetails.rejected, (state) => {
            console.log('REJECTED');
            state.loading = false;
            state.error = TicketError.LOADING_FAILED;
        })

        // === Vault Ticket ===
        builder.addCase(submitVaultTicket.pending, (state) => {
            console.log('PENDING');
            state.vaultLoading = true
        })
        builder.addCase(submitVaultTicket.fulfilled, (state, action: PayloadAction<boolean>) => {
            console.log('FULFILLED');
            state.vaultLoading = false;
            state.vaultSuccessful = 'COMPLETED'; // Use the payload value from the action
            state.error = TicketError.NONE;
          });          
        builder.addCase(submitVaultTicket.rejected, (state) => {
            console.log('REJECTED');
            state.vaultLoading = false;
            state.error = TicketError.VAULTING_FAILED;
        })
    }
})

// Selectors
export const selectTickets = (state: TicketsState) => state.tickets;
export const selectTicket = (state: TicketsState, ticketId?: number) => {
    if(!ticketId || String(state.tickets) == JSON.parse('{}')) return undefined;
    return state.tickets.get(ticketId)
};
export const selectTicketError = (state: TicketsState) => state.error;
export const selectTicketFetchStatus = (state: TicketsState) => state.loading;
export const selectVaultLoadingStatus = (state: TicketsState) => state.vaultLoading;
export const selectVaultingSuccessStatus = (state: TicketsState) => state.vaultSuccessful;

export default ticketsSlice.reducer